"use strict";

module.exports = {
  'name': 'map',
  'category': 'Matrix',
  'syntax': ['map(x, callback)'],
  'description': 'Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array.',
  'examples': ['map([1, 2, 3], square)'],
  'seealso': ['filter', 'forEach']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/matrix/map.js
// module id = 897
// module chunks = 0